import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaArrowRight
} from 'react-icons/fa';

import './cssfile/footer.css';

class Footer extends React.Component {
  render() {
    return (
      <footer className="et-footer">

        <div className="et-footer-container">

          {/* ================= TOP FOOTER ================= */}
          <div className="et-footer-grid">

            {/* BRAND / CONTACT */}
            <div className="et-footer-column et-footer-about">

              <Link to="/home" className="et-footer-brand">
                <span className="et-footer-brand-mark">
                  E
                </span>

                <span>
                  ErwaToday
                  <small>Online Learning & Mock Tests</small>
                </span>
              </Link>

              <p className="et-footer-description">
                Prepare smarter with online mock tests, practice
                resources and competitive examination materials.
              </p>

              <div className="et-footer-contact">

                <div className="et-contact-item">
                  <span className="et-contact-icon">
                    <FaMapMarkerAlt />
                  </span>

                  <span>
                    192/2 Opposite Public Garden,
                    Car Park Stand,
                    Sector 3A New, Infocity,
                    Gandhinagar, Ahmedabad,
                    Gujarat - 382016
                  </span>
                </div>

                <a
                  href="tel:9608372362"
                  className="et-contact-item"
                >
                  <span className="et-contact-icon">
                    <FaPhoneAlt />
                  </span>

                  <span>
                    9608372362
                  </span>
                </a>

                <a
                  href="mailto:administrative@erwatoday.in"
                  className="et-contact-item"
                >
                  <span className="et-contact-icon">
                    <FaEnvelope />
                  </span>

                  <span>
                    administrative@erwatoday.in
                  </span>
                </a>

              </div>

            </div>


            {/* CONNECT */}
            <div className="et-footer-column">

              <h4 className="et-footer-title">
                Connect With Us
              </h4>

              <p className="et-footer-subtitle">
                Follow ErwaToday for updates and announcements.
              </p>

              <div className="et-social-links">

                <a
                  href="https://www.facebook.com/erwatoday"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="et-social-link"
                >
                  <FaFacebook />
                  <span>Facebook</span>
                </a>

                <a
                  href="https://twitter.com/sikanda47058982"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="et-social-link"
                >
                  <FaTwitter />
                  <span>Twitter</span>
                </a>

                <a
                  href="https://www.youtube.com/@erwatoday"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="et-social-link"
                >
                  <FaYoutube />
                  <span>YouTube</span>
                </a>

                <a
                  href="#instagram"
                  className="et-social-link"
                  onClick={(e) => e.preventDefault()}
                >
                  <FaInstagram />
                  <span>Instagram</span>
                </a>

              </div>

            </div>


            {/* COMPANY */}
            <div className="et-footer-column">

              <h4 className="et-footer-title">
                Company
              </h4>

              <div className="et-footer-menu">

                <Link to="/aboutus">
                  <FaArrowRight />
                  About Us
                </Link>

                <Link to="/contactus">
                  <FaArrowRight />
                  Contact Us
                </Link>

                <Link to="/privacy">
                  <FaArrowRight />
                  Privacy Policy
                </Link>

                <Link to="/termscondition">
                  <FaArrowRight />
                  Terms & Conditions
                </Link>

                <Link to="/paymentc">
                  <FaArrowRight />
                  Payment / Refund / Cancellation
                </Link>

              </div>

            </div>

          </div>


          {/* ================= BOTTOM FOOTER ================= */}

          <div className="et-footer-bottom">

            <p>
              © 2022-{new Date().getFullYear()} ErwaToday.in.
              All Rights Reserved.
            </p>

            <div className="et-footer-bottom-links">

              <Link to="/privacy">
                Privacy
              </Link>

              <Link to="/termscondition">
                Terms
              </Link>

              <Link to="/contactus">
                Contact
              </Link>

            </div>

          </div>

        </div>

      </footer>
    );
  }
}

export default Footer;